import { keyframes } from 'styled-components';
import styled, { useTheme } from 'foundations-theming/utils';
import { rgba } from 'foundations-components/transitional/utils/color';
const shimmerAnimation = keyframes(["0%{left:-50%;}100%{left:100%;}"]);
export const SkeletonWrapper = styled.div.withConfig({
  displayName: "Skeleton__SkeletonWrapper",
  componentId: "sc-1jp1ljk-0"
})(["overflow:hidden;position:relative;border-radius:", ";height:", ";width:", ";display:", ";opacity:", ";&::before{z-index:1;content:'';display:block;position:absolute;width:50%;height:100%;top:0;left:-50%;animation:", " 1s cubic-bezier(0.42,0,0.58,1) infinite;background:linear-gradient( to right,transparent 0%,", " 50%,transparent 100% );}"], ({
  borderRadius
}) => borderRadius, ({
  height
}) => height, ({
  width
}) => width, ({
  display
}) => display, ({
  opacity
}) => opacity, shimmerAnimation, ({
  shimmerColor,
  theme
}) => shimmerColor || rgba(theme.color['fill-surface-default'], 0.65));
export const SkeletonBlock = styled.div.withConfig({
  displayName: "Skeleton__SkeletonBlock",
  componentId: "sc-1jp1ljk-1"
})(({
  borderBottomLeftRadius,
  borderBottomRightRadius,
  color = 'fill-accent-neutral-subtle-alt',
  height,
  width
}) => {
  const theme = useTheme();
  return {
    backgroundColor: theme.color[color],
    borderBottomLeftRadius,
    borderBottomRightRadius,
    height,
    width
  };
});